import * as z from "zod";
import { mutator } from "./mutator";

export const testConnectorSchema = z.object({
  connectedAppId: z.string(),
});

export const testConnectedApp = mutator({
  schema: testConnectorSchema,
  resolve: {
    app: { kind: "connectedApp", from: "connectedAppId" },
  },
  permissions: [
    {
      permission: "connected_app:use",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, args: { app } }) => {
    await tx.mutate.connectedApps.update({
      id: app.id,
      lastTestAt: Date.now(),
      lastTestStatus: "pending",
    });
  },
});
